<template>
  <div class="search">
    <div class="search__columns">
      <div class="search__column search__column--shrink">
        <img :src="searchIconSrc" alt="magnifying-glass" class="search__image">
      </div>
      <div class="search__column">
        <form @submit.prevent="handleSearch">
          <input
            v-model="searchTerm"
            type="search"
            :placeholder="placeholder"
            class="search__input"
            ref="searchInput"
          >
        </form>
      </div>
      <div v-if="shouldShowClear" class="search__column search__column--shrink">
        <button
          class="search__button search__button--text"
          :class="{ 'search__button--hidden': !this.hasSearchTerm }"
          :style="colorStyles"
          @click="clearInput"
        >
          Clear
        </button>
      </div>
      <div class="search__column search__column--shrink">
        <button class="search__button" :style="buttonStyles" @click="handleSearch">Search</button>
      </div>
    </div>
  </div>
</template>

<script>
// Vue1 `require('...svg')` -> ES-module import so Vite resolves the asset
// (inlined as a data URI under the build's assetsInlineLimit).
import searchSvg from '../../assets/v3-assets/search.svg';

export default {
  name: 'search',
  computed: {
    searchIconSrc() {
      return searchSvg;
    },

    clearButtonWrapperClass() {
      if (this.searchTerm.length > 0) {
        return 'button-wrapper clear-button';
      }

      return 'button-wrapper clear-button invisible';
    },

    colorStyles() {
      return {
        color: this.theme.accent,
      };
    },

    buttonStyles() {
      // @FIXME: there's prob a better way to do this but hopefully it's a temp fix
      const color = this.theme.type === 'light' ?
        this.theme.background :
        this.theme.text;
      return {
        backgroundColor: this.theme.accent,
        color,
      };
    },

    hasSearchTerm() {
      return this.searchTerm.trim().length > 0;
    },

    shouldShowClear() {
      return document.body.offsetWidth > 400;
    },
  },
  methods: {
    handleSearch() {
      const sanitizedSearchTerm = this.searchTerm.trim().toLowerCase();
      this.handleOnPressSearch(sanitizedSearchTerm);
    },

    clearInput() {
      this.searchTerm = '';
    },

    // Public focus hook the parent Player calls after opening the search modal
    // (replaces the Vue1 `this.$refs.search.$els.searchInput` reach-through).
    focusInput() {
      if (this.$refs.searchInput) this.$refs.searchInput.focus();
    },
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  props: {
    placeholder: {
      type: String,
      default: 'Keyword Search',
    },
    handleOnPressSearch: {
      type: Function,
      default: () => {},
    },
    handleCloseSearchModal: {
      type: Function,
      default: () => {},
    },
    theme: {
      type: Object,
      validator(value) {
        return ['light', 'dark', 'custom'].includes(value.type);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$screen-sm: 540px;

.search {
  border: 2px solid #DADAE0;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  &__columns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -0.5rem;
  }

  &__column {
    padding: 0 0.5rem;
    min-width: 0;

    &--shrink {
      flex: 0 0 auto;
    }
  }

  &__image {
    display: block;
  }

  &__input {
    border: 0;
    font-size: 1rem;
    max-width: 100%;
    &:focus {
      outline: 0;
    }
  }

  &__button {
    font-size: 1rem;
    border: 0;
    background: transparent;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    cursor: pointer;
    @media (min-width: $screen-sm) {
      padding: 0.5 2rem;
    }
    &--text {
      padding: 0.5rem;
    }
    &--hidden {
      visibility: hidden;
    }
  }
}

/* clears the ‘X’ from Internet Explorer */
input[type=search]::-ms-clear { display: none; width : 0; height: 0; }
input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }
/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration { display: none; }
</style>
